import React, { useContext, useEffect, useState } from 'react';
import {  Outlet, Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const PrivateAdminRoute = () => {
  const { isAuthenticated,isAdmin } = useContext(AuthContext);
  const [isChecked, setisChecked] = useState(false);

  useEffect(()=>{
    setisChecked(true)
  },[])
  if (!isAuthenticated && isChecked) {
    return <Navigate to="/login" />; // Redirect to login if not authenticated
  }

  if (isAuthenticated && !isAdmin && isChecked) {
    return <Navigate to="/login" />; // Redirect to login if not authenticated
  }

 

  return <Outlet />
};

export default PrivateAdminRoute;
